<template>
  <fieldset v-show="showGroup" class="vf-field-group" :class="{ 'is-last': isLast }">
    <legend v-if="group.show_title">{{ group.title }}</legend>
    <div v-if="group.summary" v-html="group.summary" class="vf-group-message"></div>
    <template v-if="group.fields">
      <field-holder
        v-for="field in group.fields" 
        :options="field" 
        :key="field.id"
        :ref="'field-' + field.id">
      </field-holder>
    </template>
  </fieldset>
</template>

<script>
import {_} from 'vue-underscore'
import FieldHolder from './FieldHolder.vue';

export default { 
  name: 'FieldGroup',
  components: {
    FieldHolder
  },
  props: {
    group: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean
    }
  },
  methods: {
    /* Determine if field group should be hidden (if conditional) */
    showGroup () {
      let vm = this
      if (this.group.conditional) {
        this.show = false
        _.find(vm.group.display_rules, function(rule) { 
          let trigger_field = 'field-' + rule.field_id
          let trigger_value = rule.trigger_value
          let current_value = vm.$store.getters.formData[trigger_field]
          let match = vm.$util.setValue(current_value).checkIfMatch(
            trigger_value, rule.condition, rule.type
          )
          if (match) {
            vm.show = true
          }
        })
      } else {
        vm.show = true
      }
    },
    validate () {
      const self = this
      let is_valid = true
      _.each(this.group.fields, function(field) {
        // Get the vue component object for this field
        let obj = self.$refs['field-' + field.id][0]
        if (field.required) {
          //console.log(field.id, 'is required')
          if (field.conditional == 0 || (field.conditional == 1 && obj.showField)) {
            let result = obj.validate()
            //console.log('validation result', result)
            if (result === false) {
              is_valid = false
            }
          }
        }
      })
      return is_valid
    }
  },
  computed: {
    formData () {
      return this.$store.formData
    }
  },
  watch: {
    formData: {
      handler () {
        this.showGroup()
     },
     deep: true
    }
  },
  mounted () {
    this.showGroup()
  }
}
</script>
